import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, NavParams, AlertController, ModalController, Events } from 'ionic-angular';

import { ProjectDetailPage } from '../project-detail/page';
import { FormProjectPage, LoginPage, ProfilePage, ActivityPage } from '../';

import { Project, User, Master } from '@providers/index';
import { FilterProjectApps } from '@src/components/Content';

@Component({
  selector: 'page-list-project',
  templateUrl: 'page.html'
})
export class ListProjectPage {

  user:any={};
  listProject:any = [];
  total_rows=0;
  listStage:any = [];
  params:any = {};
  title= "List Project";
  akses:any={};
  panelSearch=false;

  currentPage = 1;
  pageSize = 50;
  total_page = 0;

  constructor(
    public navCtrl     : NavController,
    public toastCtrl   : ToastController,
    public loadingCtrl : LoadingController,
    public navParams   : NavParams,
    public alertCtrl   : AlertController,
    public projectApi  : Project,
    public masterApi   : Master,
    public userApi     : User,
    public modalCtrl: ModalController,
    public events:  Events
  ) {
    this.params.all_sbu = 1;
    if(this.userApi.akses.lihat_project_group_data=="all"){
      this.params.all_branch = 1;
      this.params.all_company = 1;
      this.params.all_sbu = 1;
    }

    if(this.navParams.get('params')!=undefined){
      this.params = this.navParams.get('params');
    }
    this.akses = this.userApi.akses;
    this.user = this.userApi.data;

    // if(this.userApi.akses.lihat_project_group_data=='branch'){

    //   this.params.branch_ids = this.userApi.data.hrm_company_office_id,
    //   this.params.company_ids = this.userApi.data.company_id
 
    // }else if(this.userApi.akses.lihat_project_group_data=='sbu'){
    //   this.params = {
    //     all_company : 1,
    //     all_branch : 1,
    //     sbu_ids : this.userApi.data.division_id
    //   }
    // }else 
    if(this.userApi.akses.lihat_project_group_data=='mine'){
      this.params = {
        created_by : this.userApi.data.employee_id
      }
    }
    // else if(this.userApi.akses.lihat_project_group_data=='fitur_user_data'){
    //   this.params=this.userApi.akses.lihat_project_user_data;
    // }

    if(this.navParams.get('params')!=undefined){
      let parameter = this.navParams.get('params');
      if(parameter.dept_id!=undefined){
        this.params.dept_id = parameter.dept_id;
      }
    }
    let me = this;
    this.events.subscribe('project:filter_list_project', (params) => {
      me.params.keyword = params.keyword;
      me.currentPage = 1;
      me.pageSize    = 50;
      me.total_rows  = 0;
      me.total_page  = 0;
      me.getList();
    })

    this.events.subscribe('project:cancel_filter_list_project', () => {
      me.currentPage = 1;
      me.pageSize    = 50;
      me.total_rows  = 0;
      me.total_page  = 0;
      me.getList();
    })
  }

  getDisclaimer(){
    this.masterApi.getDisclaimer().subscribe((resp:any) => {
      if(resp.disclaimer!=''){
        let pop = this.alertCtrl.create({
          title   : 'Notice',
          subTitle: resp.disclaimer,
          buttons : ['OK']
        });
        pop.present();
      }
    }); 
  }

  ionViewDidLoad(){
    this.getDisclaimer();
  }

  ionViewDidEnter() {
    this.getList();
    //this.getStage();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  showFilter() {
    let me = this;
    let cmpFilter = this.modalCtrl.create(
      FilterProjectApps,
      { data: null, title: "Filter List Project", page: "list_project" },
      { cssClass: "select-modal", enableBackdropDismiss: false }
    );
    cmpFilter.present();
  }
  
  showSearch(){
    this.panelSearch=true;
  }
  hideSearch(){
    this.panelSearch=false;
  }
  getStage(){
    let params = {};
    this.masterApi.stage(params).subscribe((resp:any) => {
      this.listStage = resp.data;
      
    });
  }

  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params:any = this.params;
    params.page     = this.currentPage,
    params.pageSize = this.pageSize
    this.projectApi.get(params).subscribe((resp:any) => {
      this.listProject = resp.data;
      this.total_rows = resp.total_rows;
      this.total_page = this.total_rows/this.pageSize;
      this.total_page = Math.ceil(this.total_page);
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  toProjectDetail(item) {
    this.navCtrl.push(ProjectDetailPage, {
      project_id: item.id,
      project_code: item.project_code,
    });
  }

  add() {
    this.navCtrl.push(FormProjectPage, {});
  }

  stageChange(e,rec){
    this.getList();
  }
  onInput(e){
    this.currentPage = 1;
    this.pageSize    = 50;
    this.total_rows  = 0;
    this.total_page  = 0;
    this.getList();
  }

  onCancel(e){
    this.currentPage = 1;
    this.pageSize    = 50;
    this.total_rows  = 0;
    this.total_page  = 0;
    this.getList();
  }

  confirmLogout() {
    const confirm = this.alertCtrl.create({
      title: 'Yakin akan keluar ?',
      buttons: [
        {
          text: 'Tidak',
          handler: () => {

          }
        },
        {
          text: 'Ya',
          handler: () => {
            this.logout();
          }
        }
      ]
    });
    confirm.present();
  }

  logout(){
    localStorage.clear();
    this.navCtrl.push(LoginPage);
  }

  toProfile(){
    this.navCtrl.push(ProfilePage);
  }

  toActivity(){
    let pids = [];
    this.listProject.forEach(rec => {
      pids.push(rec.id);
    });
    this.navCtrl.push(ActivityPage,{
      project_ids : pids
    });
  }

  first(){
    this.currentPage=1;
    this.getList()
  }
  last(){
    this.currentPage=this.total_page;
    this.getList()
  }
  next(){
    this.currentPage++;
    this.getList()
  }
  prev(){
    this.currentPage--;
    this.getList()
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/list-project/page.ts